import { Table, Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { FecThirdPartyMapping } from '../../../../../../types/fecThirdPartyMapping'
import { ThirdPartyTableRow } from '../ThirdPartyTableRow'

interface ThirdPartyTableBodyProps {
  hasStatus: boolean
  isLoading: boolean
  mappings: FecThirdPartyMapping[]
}

export const ThirdPartyTableBody = ({ hasStatus, isLoading, mappings }: ThirdPartyTableBodyProps): ReactElement => {
  const { t } = useTranslation()

  if (isLoading) {
    return <Table.Skeleton columns={3} />
  }

  if (mappings.length === 0) {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={3}>
            <Typography.Text>
              {t('settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.empty')}
            </Typography.Text>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    )
  }

  return (
    <Table.Body>
      {mappings.map((mapping) => (
        <ThirdPartyTableRow hasStatus={hasStatus} key={mapping.id} mapping={mapping} />
      ))}
    </Table.Body>
  )
}
